import {Component, input, output} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.css',
  imports: [NgClass]
})
export class SwitchComponent {

  label = input.required<string>();
  checked = input.required<boolean>();
  change = output<boolean>();
  disabled = input(false);

  toggle(event: any) {
    event.stopPropagation();
    this.change.emit(!this.checked());
  }
}
